import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const isFor = ['Tu hijo se aísla, te ignora o las discusiones son cada vez más frecuentes.', 'Sentís que perdiste la conexión y no sabés cómo volver a acercarte.', 'Querés una solución práctica, paso a paso, que podás aplicar desde hoy.', 'Estás dispuesta a dedicar 15 minutos al día durante 7 días.'];
const isNotFor = ['Buscás una solución mágica sin ningún esfuerzo personal.', 'No estás dispuesta a cambiar tu forma de comunicarte por 7 días.', 'Buscás métodos de disciplina militar o castigos físicos.'];
export function WhoIsForSection() {
  return <section className="py-10 md:py-24 bg-maternal-cream" data-id="element-276">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-277">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" data-id="element-278">
          {/* IS FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border-t-4 border-green-500" data-id="element-279">
            <h3 className="text-2xl font-bold text-maternal-brown mb-8 flex items-center" data-id="element-280">
              <span className="bg-green-100 text-green-600 p-2 rounded-full mr-3" data-id="element-281">
                <Check className="w-6 h-6" data-id="element-282" />
              </span>
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-283">
              {isFor.map((text, i) => <li key={i} className="flex items-start" data-id="element-284">
                  <Check className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-285" />
                  <span className="text-maternal-lightBrown leading-relaxed" data-id="element-286">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-maternal-beige p-8 md:p-10 rounded-3xl shadow-md border-t-4 border-red-400" data-id="element-287">
            <h3 className="text-2xl font-bold text-maternal-brown mb-8 flex items-center" data-id="element-288">
              <span className="bg-red-100 text-red-500 p-2 rounded-full mr-3" data-id="element-289">
                <X className="w-6 h-6" data-id="element-290" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-291">
              {isNotFor.map((text, i) => <li key={i} className="flex items-start" data-id="element-292">
                  <X className="w-6 h-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-293" />
                  <span className="text-maternal-lightBrown leading-relaxed" data-id="element-294">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}